import { client } from './generated/v1/client.gen'
import { attachInterceptors } from './interceptors'

attachInterceptors(client)

export { client as v1Client }
